import React, { Component } from 'react'
import get from 'lodash/get'
import { Flex, Button } from 'antd-mobile'
import SwipeableBottomSheet from 'react-swipeable-bottom-sheet'
import Scrollbar from 'smooth-scrollbar-react'
import uuidv4 from 'uuid/v4'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import array from 'lodash/array'
import _ from 'lodash'
import cx from 'classnames'
import Modal from './Modal'
import previousArrowImage from '../assets/images/previous-arrow.png'
import DialogComponent from './../containers/hoc/Dialog'
import ItemOptionsTotalContainer from '../containers/components/ItemOptionTotal'
import OptionGroupsContainer from '../containers/components/OptionGroups'
import WaiterOptionGroupsContainer from '../containers/components/WaiterOptionGroups'
import OptionGroupsButtonsContainer from '../containers/components/OptionGroupsButtons'
import { MERCHANT_RYOU } from '../constants/merchant'
import NativeStepper from './NativeStepper'
import NativeRadioInput from './NativeRadioInput'
import { STEPPER_MAX } from '../constants/app'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

class StepperComponent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      stepperItemInfo: '',
      isClickable: false,
      isRenderBottomActionSheet: false,
      isTriggerBottomActionSheet: false,
      isNullParamsByBottomSheet: undefined,
      isOpenModal: false,
      showDialog: false,
      setPrice: 0,
      showOption: {},
    }
    this._isMounted = false
  }

  componentDidMount = () => {
    this._isMounted = true
    this.initRequiredStepItem()
  }

  componentWillUnmount = () => {
    this._isMounted = false
  }

  shouldShowStepperElement = (merchant, category) => {
    const excludedMerchants = [MERCHANT_RYOU]
    if (excludedMerchants.includes(get(merchant, 'id'))) {
      return get(category, 'name', '').includes('聖誕')
    } else {
      return true
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.match.params.step !== this.props.match.params.step) {
      setTimeout(() => {
        if (this._isMounted) {
          // reset stepperItemInfo after update.
          this.setState({ stepperItemInfo: '' })
        }
      }, 10)
    }
  }

  shouldComponentUpdate = (nextProps, nextState) => {
    const {
      stash,
      stashByOptionGroups,
      isActiveBottomSheetSubmitButton,
    } = this.props
    if (stashByOptionGroups !== nextProps.stashByOptionGroups) {

    } else {
      if (isActiveBottomSheetSubmitButton !== nextProps.isActiveBottomSheetSubmitButton) {
        return false
      }
    }

    if (this.state.isClickable !== nextState.isClickable) {
      return true
    }

    if (stash !== nextProps.stash || stashByOptionGroups !== nextProps.stashByOptionGroups) {
      if (!nextProps.stash.dishId) {
        this.toggleBottomActionSheet(false)
      }
    }

    if (this.state.isTriggerBottomActionSheet && nextState.isTriggerBottomActionSheet) {
      if (stashByOptionGroups !== nextProps.stashByOptionGroups) {
        return false
      }
      return true
    }

    return stash !== nextProps.stash || !stash.dishId
  }

  initRequiredStepItem = () => {
    const {
      isSold,
      stepMin,
      stepMax,
      category,
      menuId,
      item,
      itemId,
      itemName,
      itemPrice,
      itemGroups,
      itemDiscount,
      setStep,
      priceUndetermined,
    } = this.props
    if (item && item.required) {
      const isMultipale = !isSold && (stepMin > 1 || stepMax > 1 || typeof stepMin === 'undefined')
      const isNotRequired = !isSold && itemId.startsWith('0-')
      const isStepper = isMultipale && !isNotRequired
      const initQty = 0
      const overrideMinMax = setStep && setStep.overrideMinMax
      const increaseAmount = overrideMinMax ? stepMax : item.max || STEPPER_MAX
      this.handleStepperOnChange(isStepper, category, menuId, itemId, itemName, itemPrice, itemGroups, initQty, itemDiscount, setStep, priceUndetermined, true, increaseAmount)()
    }
  }

  // Stepper onIncrement +1
  onIncrement = (isStepper, { category, menuId, itemId, itemName, itemPrice, itemGroups, itemDiscount, setStep, priceUndetermined }, event) => {
    const currentQty = this.getItemQuantity(this.props)
    this.handleStepperOnChange(true, category, menuId, itemId, itemName, itemPrice, itemGroups, currentQty, itemDiscount, setStep, priceUndetermined, true, 1)()
  }

  // Stepper onDecrement -1
  onDecrement = (isStepper, { category, menuId, itemId, itemName, itemPrice, itemGroups, itemDiscount, setStep, priceUndetermined }, event) => {
    const currentQty = this.getItemQuantity(this.props)
    this.handleStepperOnChange(true, category, menuId, itemId, itemName, itemPrice, itemGroups, currentQty, itemDiscount, setStep, priceUndetermined, false, -1)()
  }

  handleStepperOnChange = (isStepper, category, menuId, itemId, itemName, itemPrice, itemGroups, currentQty, itemDiscount, setStep, priceUndetermined, isIncrement, increaseAmount, useStepperValue = false) => stepperValue => {
    const {
      setStash, // set stash for option sheet at bottom
      orders,
      match,
      stepperWithSlideTo,
      merchant,
    } = this.props

    // itemGroups for that menu item
    let _stepperValue = 0
    let totalPrice = 0

    if (useStepperValue) {
      _stepperValue = stepperValue
      totalPrice = itemDiscount ? (itemPrice - itemDiscount) * stepperValue : itemPrice * stepperValue
    } else if (isStepper) {
      // > isStepper
      // stepperValue is click event
      // if type is stepper, stepper can increase and decrease value
      _stepperValue = Math.max(currentQty + increaseAmount, 0)
      totalPrice = itemDiscount ? (itemPrice - itemDiscount) * _stepperValue : itemPrice * _stepperValue
    } else {
      // > isRadio
      isIncrement = (currentQty === 0)
      _stepperValue = isIncrement ? 1 : 0
      totalPrice = itemDiscount ? itemPrice - itemDiscount : itemPrice
    }

    let _result
    let isSet

    if (!isIncrement) {
      _result = _.find(orders, item => item.dishId === itemId)
      isSet = (_result && _result.steps !== undefined && _result.steps.length > 0)
    }

    // update stepper item at current step
    this.setState({
      isClickable: true,
      stepperItemInfo: {
        item: this.props.item,
        merchantId: merchant.id,
        isStepper: isStepper,
        isIncrement: isIncrement,
        quantity: _stepperValue,
        dish: itemName,
        dishId: itemId,
        menuId: menuId,
        category: category,
        itemGroups: itemGroups,
        isSet: isSet,
        setStep: setStep,
        price: itemPrice,
        priceUndetermined: priceUndetermined,
        discount: itemDiscount,
        total: totalPrice,
        options: [],
        remarks: [],
        setItems: _.get(this.props, 'item.items'),
      },
    }, () => {
      if (_.isEmpty(match.params || match.params.id)) {
        if (typeof stepperWithSlideTo === 'function') {
          // callback
          stepperWithSlideTo()
        }
      }

      if (isIncrement && itemGroups && itemGroups.length) {
        // if menu item has item groups
        // before showing option sheet at bottom, update stepper data in redux state.stash
        setStash(this.state.stepperItemInfo)
        return this.setState(
          { isRenderBottomActionSheet: true },
          () => {
            setTimeout(() => {
              this.toggleBottomActionSheet(true)
              this.checkOptionGroupMin()
            }, 100)
          })
      }

      if (isIncrement) {
        // > isIncrement
        this.addOrder()
      } else {
        // > isDecrement
        // quantity is reduced for current menu item
        // Remove
        if (itemGroups && itemGroups.length) {
          // Remove with item groups
          const _stepperItemInfo = this.state.stepperItemInfo

          const _result = _.find(orders, (item, index) => {
            if (_.isEmpty(item.steps)) {
              return item.dishId === _stepperItemInfo.dishId
            } else {
              return _.find(item.items, (_item, _index) => {
                return _item.dishId === _stepperItemInfo.dishId
              })
            }
          })

          if (!_.isEmpty(_result)) {
            // > isSet
            if (!_.isEmpty(_result.steps)) {
              const currentStepItem = _.find(_result.items, (_item, _index) => {
                return _item.dishId === _stepperItemInfo.dishId
              })
              if (currentStepItem.options.length === 1 && currentStepItem.remarks.length === 1) {
                this.addOrder()
              } else {
                this.setState({ isOpenModal: true })
              }
              // > !isSet
            } else {
              if (_result.options.length === 1 && _result.remarks.length === 1) {
                this.addOrder()
              } else {
                this.setState({ isOpenModal: true })
              }
            }
          }
        } else if (isSet && _result.quantity > 1) {
          // only show dialog when quantity > 1
          this.setState({ isOpenModal: true })
        } else {
          // Remove without item groups
          let shouldOpenModal = _result ? (_result.remarks.length > 1) : false // > open delete item by remark dialog
          let isAllRemarksEmpty = true

          if (_result) {
            _result.remarks.forEach((ele) => {
              if (ele.length !== 0) {
                isAllRemarksEmpty = false
              }
            })
          }

          shouldOpenModal = shouldOpenModal && !isAllRemarksEmpty

          if (shouldOpenModal) {
            this.setState({ isOpenModal: true })
          } else {
            this.addOrder()
          }
        }
      }
    })
  }

  // 點沒有選項的餐點時直接 addToOrder
  addOrder = (index) => {
    // update order with stepper item info at current step
    const { addToOrder, waiter } = this.props
    addToOrder({
      ...this.state.stepperItemInfo,
      isModifyByNumberPad: waiter.numberPad.value !== '',
    }, index).then(() => {
      if (this._isMounted) {
        this.setState({
          isClickable: false,
          isOpenModal: false,
        })
      }
    })
  }

  // 有選項的餐點，選完選項後按下確認提交，連 options 一起 addToOrder
  confirmOrder = () => {
    const {
      stash,
      stashByOptionGroups,
      addToOrder,
      resetStash,
      resetStashByOptionGroups,
      resetStashByRadioGroups,
      waiter,
    } = this.props

    addToOrder({
      ...stash,
      options: stashByOptionGroups.reduce((acc, val) => acc.concat(val.options), []),
      isModifyByNumberPad: waiter.numberPad.value !== '',
    }).then(() => {
      this.setState({ isNullParamsByBottomSheet: undefined },
        () => {
          this.toggleBottomActionSheet(false)
          this.scrollbar.contentEl.style.transform = 'translate3d(0px, 0px, 0px)'
          resetStash()
          resetStashByOptionGroups()
          resetStashByRadioGroups()
        })
    })
  }

  toggleBottomActionSheet = (open) => {
    if (this.state.isTriggerBottomActionSheet === open) return

    this.setState(
      { isTriggerBottomActionSheet: open },
      () => {
        this.props.switchBottomSheet(open)
        this.setState({ isNullParamsByBottomSheet: undefined })
      })
  }

  triggerBottomSheetOverlayEvent = (event) => {
    const {
      resetStash,
      resetStashByOptionGroups,
      resetStashByRadioGroups,
    } = this.props

    if (!_.isEmpty(event)) {
      event.preventDefault()
      event.stopPropagation()
    }

    this.setState({ stepperItemInfo: '' })

    resetStash()
    resetStashByOptionGroups()
    resetStashByRadioGroups()
    this.toggleBottomActionSheet(false)
  }

  triggerItemOptionsOverlayEvent = () => {
    const {
      resetStash,
      resetStashByOptionGroups,
      resetStashByRadioGroups,
    } = this.props

    this.setState({
      stepperItemInfo: '',
      isOpenModal: false,
      isClickable: false,
    })

    resetStash()
    resetStashByOptionGroups()
    resetStashByRadioGroups()
  }

  renderItemOptionsTotal = () => {
    return <ItemOptionsTotalContainer />
  }

  renderItemOptionsFromStash = (itemGroups, itemId) => {
    const {
      classes,
    } = this.props
    const bottomSheetOptionListStyle = cx(classes['bottom-sheet-option-list'])

    return (
      <div className={bottomSheetOptionListStyle}>
        <div>
          {this.renderItemOptionGroupsFromStash(itemGroups, itemId)}
        </div>
      </div>
    )
  }

  renderItemOptionGroupsFromStash = (groups, dishIdByStash) => {
    const {
      classes,
      intl,
      user,
      merchant,
    } = this.props
    const bottomSheetGroupStyle = cx(classes['bottom-sheet-group'])
    // let bottomSheetGroupStyle
    // if (!user.permissions || (merchant && user.permissions && user.permissions.indexOf(merchant.id + ':waiter') == -1)) {
    // bottomSheetGroupStyle = cx(classes['bottom-sheet-group'])
    // } else {
    // bottomSheetGroupStyle = cx(classes['waiter-bottom-sheet-group']);
    // }
    const bottomSheetGroupTitleStyle = cx(classes['bottom-sheet-group-title'])
    const bottomSheetGroupTitleButtonStyle = cx(classes['bottom-sheet-group-title-button'])
    const bottomSheetTitleMinPrefix = intl.formatMessage({ id: 'bottomsheet.min.prefix' })
    const bottomSheetTitleMaxPrefix = intl.formatMessage({ id: 'bottomsheet.max.prefix' })
    const bottomSheetTitleSuffix = intl.formatMessage({ id: 'bottomsheet.suffix' })
    const bottomsheetMaxMinAnd = intl.formatMessage({ id: 'bottomsheet.max.min.and' })

    const _groups = groups.sort(compare).map((group, index) => {
      let bottomSheetTitle = group.name
      if (group.max > 1 && group.min > 1) {
        bottomSheetTitle += ' (' + group.min + bottomsheetMaxMinAnd + group.max + bottomSheetTitleSuffix
      } else if (group.max > 1 && group.min === 1) {
        bottomSheetTitle += ' ' + bottomSheetTitleMaxPrefix + group.max + bottomSheetTitleSuffix
      } else if (group.min > 1 && group.max === 1) {
        bottomSheetTitle += ' ' + bottomSheetTitleMinPrefix + group.min + bottomSheetTitleSuffix
      }
      const groupTitle = (<div className={bottomSheetGroupTitleStyle}>{bottomSheetTitle}</div>)
      let waiterOptionGroupStyles
      if (user.permissions && user.permissions.indexOf(merchant.id + ':waiter') >= 0) {
        waiterOptionGroupStyles = { width: '100%' }
      }

      const isShow = this.state.showOption[index] || false
      const isWaiter = user.permissions && user.permissions.indexOf(merchant.id + ':waiter') >= 0
      return (
        <div
          className={bottomSheetGroupStyle}
          key={`${index}-group-title`}
          style={waiterOptionGroupStyles}
        >
          {
            (group.min > 0 || !isWaiter)
              ? <div>{groupTitle}</div>
              : <Button
                className={bottomSheetGroupTitleButtonStyle}
                onClick={() => {
                  this.setState({ showOption: { ...this.state.showOption, [index]: !isShow } })
                }}
              >
                {groupTitle}
                <ExpandMoreIcon/>
              </Button>
          }

          {
            this.renderItemOptionGroupItemsFromStash(
              group.options,
              group.multiple,
              group.default,
              group.name,
              group.id,
              dishIdByStash,
              group.max,
              group.min,
              index,
            )
          }
        </div>
      )
    })

    function compare (prev, current) {
      if (prev.min > current.min) {
        return -1
      } else if (prev.min < current.min) {
        return 1
      } else {
        return 0
      }
    }

    return _groups
  }

  renderOptionGroupsContainer = (inputType, item, groupName, groupId, dishIdByStash, defaultValue, groupMax, groupMin, isMultiple) => {
    const { user, merchant } = this.props
    if (!user.permissions || (merchant && user.permissions && user.permissions.indexOf(merchant.id + ':waiter') === -1)) {
      return (
        <OptionGroupsContainer
          key={`${groupId}-group-item-${Math.random()}`}
          inputType={inputType}
          item={item}
          groupName={groupName}
          groupId={groupId}
          dishId={dishIdByStash}
          checked={item.id === defaultValue}
          groupMax={groupMax}
          groupMin={groupMin}
          checkOptionGroupMin={this.checkOptionGroupMin}
        />
      )
    } else {
      return (
        <WaiterOptionGroupsContainer
          key={`${groupId}-group-item-${Math.random()}`}
          inputType={inputType}
          item={item}
          groupName={groupName}
          groupId={groupId}
          dishId={dishIdByStash}
          checked={item.id === defaultValue}
          groupMax={groupMax}
          groupMin={groupMin}
          checkOptionGroupMin={this.checkOptionGroupMin}
          isMultiple={isMultiple}
        />
      )
    }
  }

  renderItemOptionGroupItemsFromStash = (items, isMultiple, defaultValue, groupName, groupId, dishIdByStash, groupMax, groupMin, index) => {
    const {
      user,
      merchant,
    } = this.props

    let inputType = ''
    const isWaiter = user.permissions && user.permissions.indexOf(merchant.id + ':waiter') >= 0
    if (!this.state.showOption[index] && groupMin === 0 && isWaiter) {
      return null
    }
    if (isMultiple) {
      const tmp = items.map((item, index) => {
        inputType = (item.max === 0 || item.max > 1) ? 'stepper' : 'checkbox'
        return this.renderOptionGroupsContainer(inputType, item, groupName, groupId, dishIdByStash, defaultValue, groupMax, groupMin, isMultiple)
      })
      if (user.permissions && user.permissions.indexOf(merchant.id + ':waiter') >= 0) {
        return <div style={{ display: 'flex', flexDirection: 'row', flexFlow: 'wrap' }}>{tmp}</div>
      } else {
        return <div style={{ display: 'flex', flexFlow: 'row wrap' }}>{tmp}</div>
      }
    } else {
      if (user.permissions && user.permissions.indexOf(merchant.id + ':waiter') >= 0) {
        inputType = 'checkbox'
      } else {
        inputType = 'radio'
      }
      // let _groupMin = groupMin === 0 ? 0 : groupMin;
      const _groupMax = groupMax === 1 ? 0 : groupMax

      const tmp = items.map((item, index) => {
        return this.renderOptionGroupsContainer(inputType, item, groupName, groupId, dishIdByStash, defaultValue, _groupMax, groupMin, isMultiple)
      })

      if (user.permissions && user.permissions.indexOf(merchant.id + ':waiter') >= 0) {
        return <div style={{ display: 'flex', flexDirection: 'row', flexFlow: 'wrap' }}>{tmp}</div>
      } else {
        return <div style={{ display: 'flex', flexFlow: 'row wrap' }}>{tmp}</div>
      }
    }
  }

  checkOptionGroupMin = () => {
    const {
      stash,
      stashByOptionGroups,
      activeBottomSheetSubmitButton,
    } = this.props

    const _stash = stash
    const _itemGroups = _stash.itemGroups
    const _tmpStash = []
    if (!_.isEmpty(stashByOptionGroups)) {
      _.forEach(_itemGroups, function (item, key) {
        if (item.min > 0) {
          _tmpStash.push(item)
        }
      })

      const _canSubmit = _tmpStash.every((item) => {
        const selectedItem = _.find(stashByOptionGroups, function (option) {
          return option.groupId === item.id
        })

        if (_.isEmpty(selectedItem)) {
          return false
        }
        if (selectedItem.groupOptionQty < selectedItem.groupOptionMin) {
          return false
        }

        return true
      })

      activeBottomSheetSubmitButton(_canSubmit)
    } else {
      const _canSubmitOrder = _itemGroups.every(function (item, index) {
        return item.min <= 0
      })

      activeBottomSheetSubmitButton(_canSubmitOrder)
    }
  }

  renderOptionGroupsButtons = () => {
    return (
      <OptionGroupsButtonsContainer
        confirmOrder={this.confirmOrder}
      />
    )
  }

  renderDialogComponent = () => {
    const {
      intl,
      orders,
      itemId,
    } = this.props

    // check dishoption or dishremark
    const _chooseDeleteDishOptionText = intl.formatMessage({ id: 'dialog.choose_delete_dish_option' })

    if (this.state.isOpenModal) {
      let _dialogContent = ''
      const _stepperItemInfo = this.state.stepperItemInfo
      const isSet = this.state.stepperItemInfo.isSet
      let _result

      if (!isSet) {
        if (this.state.stepperItemInfo.setStep) {
          const tmp = _.find(orders, (item, index) => {
            if (_.isEmpty(item.steps)) {
              return item.dishId === _stepperItemInfo.dishId
            } else {
              return _.find(item.items, (_item, _index) => {
                return _item.dishId === _stepperItemInfo.dishId
              })
            }
          }) || []

          const options = []
          tmp.items.forEach(ele => {
            if (ele.dishId !== itemId) {
              return
            }
            ele.options.forEach(option => {
              let name = ''
              option.forEach(opt => {
                name += opt.name + '、'
              })
              name = name.substring(0, name.length - 1)
              options.push([{ name: name }])
            })
          })

          _result = { options: options }
        } else {
          _result = _.find(orders, (item, index) => {
            if (_.isEmpty(item.steps)) {
              return item.dishId === _stepperItemInfo.dishId
            } else {
              return _.find(item.items, (_item, _index) => {
                return _item.dishId === _stepperItemInfo.dishId
              })
            }
          })
        }
      } else {
        // > isSet
        const options = []
        let name = ''
        const tmp = _.find(orders, (item, index) => {
          return item.dishId === _stepperItemInfo.dishId
        })

        tmp.items.forEach(ele => {
          name += ele.dish + '、'
        })

        name = name.substring(0, name.length - 1)

        options.push([{ name: name }])
        _result = { options: options }
      }
      _dialogContent = _result

      if (!_.isEmpty(_result)) {
        return (
          <DialogComponent
            triggerItemOptionsOverlayEvent={this.triggerItemOptionsOverlayEvent}
            dialogType='content'
            title={_chooseDeleteDishOptionText}
            contentType='options'
            optionContent={_dialogContent.options}
            remarkContent={_dialogContent.remarks}
            confirmButtonAction={this.addOrder}
            isOpen
          />
        )
      }
    }
  }

  getItemQuantity ({ orders, category, itemId }) {
    return orders.reduce((accu, order) => {
      if (!category || !category.isSet) {
        if (order.dishId === itemId) {
          if (order.steps) {
            accu = 1
          } else {
            accu += order.quantity
          }
        }
      } else {
        if ((order.dishId === category.id) && !order.confirmed) {
          const oldItem = order.items.find((item) => item.dishId === itemId)
          if (oldItem) {
            accu += oldItem.quantity
          }
        }
      }
      return accu
    }, 0)
  }

  renderBottomSheet () {
    const {
      user,
      merchant,
      classes,
      itemName,
      itemGroups,
      itemId,
      intl,
    } = this.props

    const isWaiter = user.permissions && user.permissions.indexOf(merchant.id + ':waiter') >= 0

    const simulateBottomSheetOverlayStyle = cx(classes['simulate-bottom-sheet-overlay'])
    const previousArrowImageStyle = cx(classes['previous-arrow-image'])
    const bottomSheetContainerStyle = isWaiter ? cx(classes['waiter-bottom-sheet-container']) : cx(classes['bottom-sheet-container'])
    const bottomSheetTitleStyle = cx(classes['bottom-sheet-title'])
    const titleLeftStyle = cx(classes['title-left'])
    const titleRightStyle = cx(classes['title-right'])
    const titleLeftBackgroundStyle = cx(classes['title-left-background'])
    const waiterTitleLeftBackgroundStyle = cx(classes['waiter-title-left-background'])
    const titleLeftTextStyle = cx(classes['title-left-text'])
    const titleRightPricePrefixStyle = cx(classes['title-right-price-prefix'])
    const titleRightPriceStyle = cx(classes['title-right-price'])
    const bottomSheetContentStyle = cx(classes['bottom-sheet-content'])
    const bottomSheetTotalPriceWrapStyle = cx(classes['bottom-sheet-total-price-wrap'])
    const bottomButtonStyle = cx(classes['bottom-button'])
    const backButtonStyle = cx(classes['back-button'])
    const backButtonContainerStyle = cx(classes['bottom-button-container'])
    const confirmButtonStyle = cx(classes['confirm-button'])

    const backText = intl.formatMessage({ id: 'stepper.back' })

    return (
      <Modal>
        <SwipeableBottomSheet
          defaultOpen
          fullScreen
          overflowHeight={0}
          open={this.state.isTriggerBottomActionSheet}
          style={{ zIndex: '99999' }}
          shadowTip={false}
          topShadow={false}
          bodyStyle={{ background: 'transparent', overflow: 'hidden' }}
          swipeableViewsProps={{
            disabled: true,
            onTransitionEnd: () => {
              window.groupMap = {}
              if (!this.state.isTriggerBottomActionSheet) {
                this.setState({
                  isClickable: false,
                  isRenderBottomActionSheet: false,
                })
              }
            },
          }}
        >
          {
            !isWaiter && (
              <div
                className={simulateBottomSheetOverlayStyle}
                onClick={(event) => this.triggerBottomSheetOverlayEvent(event)}
              >
                <img
                  src={previousArrowImage}
                  className={previousArrowImageStyle}
                  onClick={(event) => this.triggerBottomSheetOverlayEvent(event)}
                  alt=''
                />
              </div>
            )
          }

          {
            isWaiter && (
              <div className={backButtonContainerStyle}>
                <div className={bottomButtonStyle}>
                  <Button
                    onClick={(event) => this.triggerBottomSheetOverlayEvent(event)}
                    className={backButtonStyle}
                  >
                    {backText}
                  </Button>
                  <div className={confirmButtonStyle}>
                    {this.renderOptionGroupsButtons()}
                  </div>
                </div>
              </div>
            )
          }
          {
            isWaiter && (
              <div className={bottomSheetTitleStyle}>
                <Flex>
                  <Flex.Item>
                    <div className={waiterTitleLeftBackgroundStyle} />
                    <div className={titleLeftStyle}>
                      <div className={titleLeftTextStyle}>
                        {itemName}
                      </div>
                    </div>
                  </Flex.Item>
                  <Flex.Item className={bottomSheetTotalPriceWrapStyle}>
                    <div className={titleRightStyle}>
                      <div className={titleRightPricePrefixStyle}>
                        <FontAwesomeIcon icon='dollar-sign' />
                      </div>
                      <div className={titleRightPriceStyle}>
                        {this.renderItemOptionsTotal()}
                      </div>
                    </div>
                  </Flex.Item>
                </Flex>
              </div>
            )
          }
          <div>
            <Scrollbar innerRef={node => (this.scrollbar = node)}>
              <div className={bottomSheetContainerStyle}>
                {
                  !isWaiter && (
                    <div className={bottomSheetTitleStyle}>
                      <Flex>
                        <Flex.Item>
                          <div className={titleLeftBackgroundStyle} />
                          <div className={titleLeftStyle}>
                            <div className={titleLeftTextStyle}>
                              {itemName}
                            </div>
                          </div>
                        </Flex.Item>
                        <Flex.Item className={bottomSheetTotalPriceWrapStyle}>
                          <div className={titleRightStyle}>
                            <div className={titleRightPricePrefixStyle}>
                              <FontAwesomeIcon icon='dollar-sign' />
                            </div>
                            <div className={titleRightPriceStyle}>
                              {this.renderItemOptionsTotal()}
                            </div>
                          </div>
                        </Flex.Item>
                      </Flex>
                    </div>
                  )
                }
                <div className={bottomSheetContentStyle}>
                  {this.renderItemOptionsFromStash(itemGroups, itemId)}
                  {
                    !isWaiter && (
                      <div>
                        {this.renderOptionGroupsButtons()}
                      </div>
                    )
                  }
                </div>
              </div>
            </Scrollbar>
          </div>

        </SwipeableBottomSheet>
      </Modal>
    )
  }

  render () {
    const {
      classes,
      menuId,
      item,
      itemId,
      itemName,
      itemPrice,
      itemGroups,
      itemDiscount,
      itemMax,
      category,
      setStep,
      disableInc,
      orders,
      intl,
      match,
      isSold,
      priceUndetermined,
      merchant,
      stepMin,
      stepMax,
    } = this.props

    const wrapStyle = cx(classes.wrap)
    const soldOutTextStyle = cx(classes['sold-out-text'])
    const soldOutText = intl.formatMessage({ id: 'stepper.sold_out' })

    // > 注意 currentOrder, currentStep 跟 firstStep 在 addOrder 前都是 undefined
    // > 注意 currentStep 在完成第一步前都是 undefined
    const currentOrder = _.find(orders, order => order.dishId === match.params.id && !order.confirmed)
    const currentStep = currentOrder && currentOrder.steps && _.find(currentOrder.steps, step => step.key === match.params.step)
    const firstStep = currentOrder && currentOrder.steps && currentOrder.steps[0]

    const uuid = uuidv4()
    const itemQuantity = this.getItemQuantity(this.props)
    const isNotRequired = itemId.startsWith('0-')
    let isStepProcessing = false
    let isStepReachMaxQty = false
    const isItemReachMaxQty = (itemMax === 0) ? false : (itemQuantity >= itemMax)

    if (!_.isEmpty(match.params.step)) {
      // > 已完成套餐的 first step
      isStepProcessing = true

      if (currentOrder && currentOrder.steps) {
        if (currentStep) {
          isStepReachMaxQty = stepMax > 0 && currentStep.quantity >= stepMax
        }
      }
    } else {
      // > 套餐的 first step
      isStepProcessing = true
      const isSetMenu = _.has(match.params, 'step')

      if (isSetMenu) {
        if (!_.isEmpty(orders)) {
          if (!_.isEmpty(currentOrder)) {
            if (firstStep.max > 0) {
              isStepReachMaxQty = firstStep.quantity >= firstStep.max
            }
          }
        }
      }
    }

    let stepperElement = ''

    if (!isSold) {
      if (stepMin > 1 || stepMax > 1 || typeof stepMin === 'undefined') {
        // > 可點多次且不是'不需要'（正常的 stepper）
        if (!isNotRequired) {
          stepperElement = (
            <NativeStepper
              value={itemQuantity}
              max={
                (isStepProcessing && (isStepReachMaxQty || isItemReachMaxQty)) || disableInc
                  ? itemQuantity
                  : STEPPER_MAX
              }
              disabled={
                !!this.state.isClickable ||
                this.state.isSameClick
              }
              onMinusClick={() => this.onDecrement(true, this.props)}
              onPlusClick={() => this.onIncrement(true, this.props)}
            />
          )
        } else {
          // > isNotRequired
          // > '不需要' 可 onclick 取消，必須要有 onChange 不然會報錯。
          stepperElement = (
            <NativeRadioInput
              isNotRequried={isNotRequired}
              id={uuid}
              name={match.params.id}
              checked={itemQuantity > 0}
              onClick={this.handleStepperOnChange(false, category, menuId, itemId, itemName, itemPrice, itemGroups, itemQuantity, itemDiscount, setStep, priceUndetermined)}
              onChange={() => {}}
            />
          )
        }
      } else {
        // > 僅限單點 （可選 === false)
        stepperElement = (
          <NativeRadioInput
            isNotRequried={isNotRequired}
            id={uuid}
            name={match.params.id}
            checked={itemQuantity > 0}
            onChange={
              this.handleStepperOnChange(false, category, menuId, itemId, itemName, itemPrice, itemGroups, itemQuantity, itemDiscount, setStep, priceUndetermined)
            }
          />
        )
      }
    } else {
      // > isSoldOut
      stepperElement = (
        <div className={soldOutTextStyle}>
          {soldOutText}
        </div>
      )
    }

    return (
      <div className={wrapStyle}>
        {this.renderDialogComponent()}
        {this.shouldShowStepperElement(merchant, category) && stepperElement}
        {this.state.isRenderBottomActionSheet && this.renderBottomSheet()}
      </div>
    )
  }
};

/**
 * Export
 */
export default StepperComponent



// WEBPACK FOOTER //
// ./src/components/Stepper.js